export default __webpack_public_path__ + "static/media/competition_item_bg.32827d9c.png";